<template>
  <div
    v-tooltip="{
      content: tooltipContent,
      placement: 'top',
    }"
    class="compact-card"
    :class="{ 'cursor-pointer': !!cardId && isCardLoaded }"
    @click="openCardHandler"
  >
    <em
      v-if="hasStatus"
      class="card-status-icon"
      :style="{
        ...getCustomIconStyle(iconPath(cardStatusInfo.icon)),
        backgroundColor: cardStatusInfo.color,
      }"
    />
    <div class="card-title">{{ displayTitle }}</div>
  </div>
</template>

<script>
import useCardStatus from '@/utilities/composables/useCardStatus';
import useCustomIcon from '@/utilities/composables/useCustomIcon';
import useOpenCard from '@/utilities/composables/useOpenCard';

export default {
  name: 'CompactCard',
  props: {
    cardId: {
      type: String,
      required: false,
      default: '',
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
  },
  setup(props) {
    const { cardStatus } = useCardStatus(props.cardId);
    const { iconPath, getCustomIconStyle } = useCustomIcon();
    const { openCard } = useOpenCard();

    return {
      cardStatus,
      iconPath,
      getCustomIconStyle,
      openCard,
    };
  },
  computed: {
    card() {
      if (!this.cardId) return {};
      return this.$store.getters.getCards[this.cardId] || {};
    },
    displayTitle() {
      if (this.cardId && this.card.title) {
        return this.card.title;
      }
      return this.title || 'Untitled Card';
    },
    hasStatus() {
      return !!this.cardId;
    },
    cardStatusInfo() {
      return this.cardStatus || { icon: 'circle-dotted', color: '#98A2B3' };
    },
    isCardLoaded() {
      return Object.keys(this.card).length > 0;
    },
    tooltipContent() {
      return this.isCardLoaded ? '' : this.translate('itemNotFound');
    },
  },
  mounted() {
    if ((this.cardId && !Object.keys(this.card).length) || this.card.partially_loaded) {
      this.$store.dispatch('fetchCard', { cardId: this.cardId });
    }
  },
  methods: {
    openCardHandler() {
      if (!this.cardId || !this.isCardLoaded) return;
      this.openCard(this.card);
    },
  },
};
</script>

<style>
.compact-card {
  @apply flex px-[2px] bg-standard-bg rounded border border-solid border-standard-border
    gap-1 items-center box-border overflow-hidden min-w-10;

  .card-status-icon {
    @apply flex-shrink-0 w-4 h-4;
  }

  .card-title {
    @apply text-sm truncate text-text-default leading-4;
  }
}
</style>
